import api_fetch from '../utils/api_fetch';
import { storageHandler } from '../utils/storage_handler';

const packageManagerService = {
  async getPackageDetailsList(page = 1, limit = 20) {
    const offset = (page - 1) * limit;
    const params = new URLSearchParams({ offset, limit });

    return (
      await api_fetch.get(
        `/v1/get-packages?${params.toString()}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      )
    ).json();
  },

  async searchPackageDetails(
    filters = {},
    page = 1,
    sortBy,
    sortOrder,
    limit = 20
  ) {
    const offset = (page - 1) * limit;
    const params = new URLSearchParams();

    params.append('limit', limit.toString());
    params.append('offset', offset.toString());

    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        params.append(key, value);
      }
    });

    if (
      sortBy &&
      sortOrder &&
      sortBy !== 'default' &&
      sortOrder !== 'default'
    ) {
      params.append('sort_by', sortBy);
      params.append('sort_order', sortOrder);
    }

    const response = await api_fetch.get(
      `/v1/search-packages?${params.toString()}`,
      {
        Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
      },
      {}
    );

    return response.json();
  },

  async getPackageDetails(id) {
    return (
      await api_fetch.get(
        `/v1/get-package/${id}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      )
    ).json();
  },

  async fetchAndProcessPackageSearch({
    searchValue,
    filters = [],
    dateFilter = 'default',
    sortBy,
    sortOrder,
    page = 1,
    limit = 20
  }) {
    const offset = (page - 1) * limit;
    const filterObj = {};

    filters.forEach((f) => {
      if (f.field && f.value) {
        filterObj[f.field] = f.value;
      }
    });

    if (dateFilter !== 'default') {
      filterObj.date_filter = dateFilter;
    }

    if (searchValue) {
      filterObj.tracking_number = searchValue;
    }

    const params = new URLSearchParams();
    params.append('limit', limit);
    params.append('offset', offset);

    Object.entries(filterObj).forEach(([key, value]) => {
      if (value) {
        params.append(key, value);
      }
    });

    if (
      sortBy &&
      sortOrder &&
      sortBy !== 'default' &&
      sortOrder !== 'default'
    ) {
      params.append('sort_by', sortBy);
      params.append('sort_order', sortOrder);
    }

    const response = await api_fetch.get(
      `/v1/search-packages?${params.toString()}`,
      {
        Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
      },
      {}
    );

    return response.json(); // let the component decide how to handle the response
  }
};

export default packageManagerService;
